<script lang=ts>

let { children } = $props()
</script>

<div class="text-sm font-[200] border-[.01rem] border-[#555555b2] text-[#555555b2] leading-[130%] pt-[0.2rem] rounded-full px-2 text-nowrap">{@render children()}</div>


<style lang=postcss></style>